
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { StaticPerEntities } from "../dashbord.model.ts";

interface ComplaintNatureProps {
  plaintesPerNature?: StaticPerEntities[];
}
const ComplaintNature: React.FC<ComplaintNatureProps>  = ({plaintesPerNature}) => {

  return (
    <div className="bg-white rounded-lg shadow-md w-full">
      <div className="p-4 text-md font-semibold text-gray-600 border-b border-gray-300 pb-2">
        Nature des plaintes
      </div>
      <div className="p-4 m-4">
        <div className="" style={{ maxWidth: "100%" }}>
          <DataTable
            value={plaintesPerNature}
            removableSort
            stripedRows
            size="small"
            scrollable
            scrollHeight="400px" 
            >
            <Column
              field="key"
              header="Nature de plainte"
              className="w-2/3"
            />
            <Column
              field="value"
              header="Nombre de plaintes"
              className="w-1/3"
              align={"right"}
            />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default ComplaintNature;
